export default __webpack_public_path__ + "static/media/fig_treasure@3x.052a543e.png";